<template>
    <el-container>
        <el-header>
            <head-top></head-top>
        </el-header>
        <el-container class="container">
            <el-aside>
                <el-menu
                    class="menu"
                        :collapse="!isShowMenu"
                        :collapse-transition="false"
                        :default-active="defaultActive"
                        active-text-color="#3890df"
                        background-color="#1d2b36"
                        router
                        text-color="#fff">
                    <el-menu-item :index="menu.Url" :key="index" @click="setActive(menu.Url)"
                        v-for="(menu, index) in menuData">
                        <i :class="menu.Icon" class="menu-icon menuFont"></i>
                        <span slot="title">{{$t('message.' + menu.LanguageKey)}}</span>
                    </el-menu-item>
                </el-menu>
            </el-aside>
            <el-main
                    :style="{'overflow-y': (defaultActive === 'myInvoice' && defaultActive === 'retrieval') ? 'hidden' : 'auto'}"
                    id="main">
                <div class="main_top">
                    <div class="breadcrumb left">
                        <el-breadcrumb>
                            <el-breadcrumb-item
                                    :key="index"
                                    separator="/"
                                    v-for="(item, index) in $route.meta">
                                {{$t('message.' + item)}}
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </div>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import headTop from "../components/headTop";
    import {setStore, getStore, getLocal} from "../config/mUtils";
    export default {
        name: '',
        components: {
            headTop
        },
        props: {},
        data() {
            return {
                defaultActive: getStore('activePath') ? getStore('activePath') : 'myInvoice',
                menuList: [],
                isShowMenu: true,
                isShowBack: false,
                menuData: []
            }
        },
        computed: {
            watchMenu() {
                return this.$store.state.menuCollapse;
            }
        },
        watch: {
            watchMenu(val) {
                this.isShowMenu = val;
                if (val) {
                    document.getElementsByClassName('el-main')[0].style.marginLeft = '240px';
                    document.getElementsByClassName('el-aside')[0].style.maxWidth = '240px';
                    document.getElementsByClassName('el-aside')[0].style.width = '240px';
                } else {
                    document.getElementsByClassName('el-main')[0].style.marginLeft = '50px';
                    document.getElementsByClassName('el-aside')[0].style.maxWidth = '50px';
                    document.getElementsByClassName('el-aside')[0].style.width = '50px';
                }
            }
        },
        async created() {
            this.menuData = JSON.parse(getLocal('RoleMenu'));
            // let icons = [
            //     'icon-coupons', //发票夹
            //     'icon-createtask', //发票检索
            //     'icon-barcode',//统计
            //     'icon-repair',//多语言
            //     'icon-group',//角色
            //     'icon-hetong',//公司授权
            //     'icon-addressbook',//供应商管理
            //     'icon-repair',//配置维护
            // ]
            // this.menuData.forEach((item,index) => {
            //     item.Icon = icons[index]
            // })
        },
        mounted() {
        },
        destroyed() {
        },
        methods: {
            // 点击路由设置
            setActive(val) {
                this.defaultActive = val;
                setStore('activePath', val);
            }
        }
    }
</script>
